// removed by extract-text-webpack-plugin
module.exports = {"paywall":"Paywall__paywall___9KC-v","wrapper":"Paywall__wrapper___26fAw","button":"Paywall__button___1erlr","delimiter":"Paywall__delimiter___2oHxK"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Paywall/Paywall.css
// module id = 929
// module chunks = 0